import React from 'react'
import { Link } from 'react-router-dom'

const NotFound = () => {
  return (
    <div className="tw-w-full tw-h-[75vh] tw-flex tw-justify-center tw-items-center tw-mt-20">
       <div className="tw-flex tw-flex-col tw-items-center tw-gap-5 tw-p-8 tw-shadow-sm hover:tw-shadow-xl hover:tw-shadow-gray-200 tw-border-r-2 tw-border-second-zain tw-cursor-pointer tw-transition-all tw-duration-500 tw-ease-linear">
        <span className=" tw-text-9xl tw-text-second-zain tw-font-bold">404</span>
        <span className="tw-text-7xl tw-text-second-zain tw-font-semibold">Not Found Page</span>
        <Link to="/" className=" tw-mt-5 tw-py-3 tw-px-14 tw-bg-second-zain tw-text-white tw-rounded-md hover:tw-bg-white hover:tw-text-second-zain tw-transition-all tw-duration-500 tw-ease-linear tw-border tw-border-transparent hover:tw-border-second-zain">الرئيسية</Link>
       </div>
    </div>
  )
}

export default NotFound